<template>
    <v-app-bar elevate-on-scroll class="d-print-none secondary mt-n6 mb-4 rounded-card" >
      <span class="headline primary--text text--lighten-1 me-8">{{this.$i18n.t(title) + ''}}</span>
      <v-tooltip bottom v-for="button in left_buttons" :key="button.index">
         <template v-slot:activator="{on}">
            <v-btn
                large
                elevation="2"
                class="primary--text mx-4 font-weight-medium"
                v-on="on"
                v-on:click="$emit('menu-click', button.index)"
            >
                <v-icon v-if="button.icon"
                        color="primary"
                        :class="{   'mx-8': !button.text,
                                    'mx-2': button.text   }"
                >
                    {{button.icon}}
                </v-icon>
                {{button.text}}
            </v-btn>
         </template>
         <span>{{button.tooltip}}</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom v-for="button in right_buttons" :key="button.index">
         <template v-slot:activator="{on}">
            <v-btn
                large
                elevation="2"
                class="primary--text mx-4 font-weight-medium"
                v-on="on"
                v-on:click="$emit('menu-click', button.index)"
            >
                <v-icon v-if="button.icon"
                        color="primary"
                        :class="{   'mx-8': !button.text,
                                    'mx-2': button.text   }"
                >
                    {{button.icon}}
                </v-icon>
                {{button.text}}
            </v-btn>
         </template>
         <span>{{button.tooltip}}</span>
      </v-tooltip>

        <v-select flat class="pe-1 py-0 mt-8 mx-2" v-if="showFilter"
            :items="dropdown_group_type"
            :label="$t('Filter') +':'"
            item-value="value"  clearable solo
            @change="$emit('filter', $event)"
            style="max-width: 240px"
            >
        </v-select>

        <v-text-field flat class="pe-1 py-0 mt-8 mx-2" v-if="showSearch"
            :label="$t('Search') +':'" clearable solo
            @input="$emit('search', $event)"
            style="max-width: 240px"
            >
        </v-text-field>

    </v-app-bar>
</template>

<script>
export default {
    name: "Submenu",
    props: {
        title: String,
        left_buttons: Array,
        right_buttons: Array,
        showFilter: {
            type: Boolean,
            default: false
        },
        showSearch: {
            type: Boolean,
            default: false
        }
    },
    emits: ['menu-click', 'filter', 'search'],
    computed: {
        dropdown_group_type() {
            return this.$store.getters.getGroupTypesForDD;
        },
    }
}
</script>

<style>
  .rounded-card {
    border-radius:4px;
  }
</style>
